import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";


export default function ConfirmCollectedModal({onCollected, open, setOpen}){


    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Vehicle Collection</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <p>Does the key need unassigning?</p>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onCollected}
                                isFullWidth
                            >
                                Collected
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => setOpen(false)}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );

}